module.exports = __webpack_public_path__ + "static/media/Chelsea---Pastel.fb6d64b5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Chelsea---Pastel.jpg
 ** module id = 425
 ** module chunks = 0
 **/